
import TableList from "@components/templates/tablelist";
import { HttpPlanBillErpSku } from '@/service/allotment';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            formData: {

            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpPlanBillErpSku,
    },
    computed: {
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_sku',
                show: true,
            },
                // {
                //     label: "描述",
                //     tag: 'vInput',
                //     key: 'CN_productsEntity.nameEn',
                //     show: true,
                // }
            ]
        },
        columns() {
            return [{
                title: "ERP SKU",
                key: 'sku'
            }, {
                title: this.$t('fbb.alloment.inventory_available', { defaultValue: "可用库存" }),
                key: 'inventoryAvailable'
            },
            // {
            //     title: "描述",
            //     key: 'nameEn'
            // }, 
            {
                title: this.$t('global.common.operation', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', { sku: row.sku, qty: row.inventoryAvailable, productId: row.productId })
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            }]
        }
    }

};
